import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import queryString from "query-string";
import InsurenceWrapper from "./StaticPage.style";
import AuthenticationApiSerivce from "../../api/AuthServices";
import { message } from "antd";

const PATHNAME_TYPE_MAP = {
  "/terms": "terms",
  "/privacy": "privacy",
  "/hipaa-consent": "hippa",
  "/hippa-consent": "hippa",
  "/payment": "payment",
};

const getStaticPageType = (location) => {
  const queryType = queryString.parse(location.search)?.type;
  if (typeof queryType === "string" && queryType.trim()) {
    return queryType.trim();
  }

  return PATHNAME_TYPE_MAP[location.pathname] ?? "";
};

const StaticPage = (props) => {
  const { i18n } = useTranslation();
  const [Data, setData] = useState({});

  useEffect(() => {
    const type = getStaticPageType(props.location);
    if (!type) {
      return undefined;
    }

    let cancelled = false;
    AuthenticationApiSerivce.staticPages({ type }, i18n.language)
      .then((res) => {
        if (!cancelled && res?.data) {
          setData(res.data);
        }
      })
      .catch(() => {
        if (!cancelled) {
          message.error("Something went wrong! Please try again.");
        }
      });

    return () => {
      cancelled = true;
    };
  }, [i18n.language, props.location.pathname, props.location.search]);

  return (
    <InsurenceWrapper>
      <div className="plrp-8 ptbp-5 ">
        <div className="row ma-0 pa-0">
          <div className="fs-40 Glacial-Bold">{Data.title}</div>
        </div>
        <div>
          <div
            className="mtp-1 fs-20 Glacial-Regular light-gray"
            dangerouslySetInnerHTML={{ __html: Data.content }}
          />
        </div>
      </div>
    </InsurenceWrapper>
  );
};

export default StaticPage;
